// Decorative by default: the control it sits in carries `aria-busy`, and a
// second announcement of the same fact is noise. Pass `label` only where the
// spinner IS the whole signal — a bare loading region with no busy control.

import { classlist } from '~/_shared/design-system/lib/classlist';

import './spinner.css';

type SpinnerSize = 'sm' | 'md';

interface SpinnerProps {
	size?: SpinnerSize;
	label?: string;
	className?: string;
}

const DIAMETER: Record<SpinnerSize, number> = { sm: 14, md: 20 };

const Spinner = ({ size = 'sm', label, className }: SpinnerProps) => {
	const diameter = DIAMETER[size];
	return (
		<svg
			role={label === undefined ? undefined : 'img'}
			aria-hidden={label === undefined ? 'true' : undefined}
			aria-label={label}
			focusable='false'
			viewBox='0 0 16 16'
			width={diameter}
			height={diameter}
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			className={classlist('spinner', `spinner--${size}`, className)}
		>
			{/* A three-quarter arc: a full circle has no visible rotation. */}
			<circle cx='8' cy='8' r='6' strokeDasharray='28' strokeDashoffset='14' />
		</svg>
	);
};

export type { SpinnerProps, SpinnerSize };
export { Spinner };
